import React from 'react';
import './loanApplicationHeader.scss';

const LoanApplicationHeader = ({ title, smallContent, children }) => {
  let appHeaderContentStyles = ["app-header-content", "text-white", "text-center"];
  if (smallContent) appHeaderContentStyles.push('small-content');
  return(
    <header className="app-header bg-barclays-secondary-dark-cyan">
      <span className="barclays-logo-white"></span>
      <section className={appHeaderContentStyles.join(' ')}>
        <h1 className="text-uppercase text-spaced app-header-title">{title}</h1>
        {children}
      </section>
    </header>);
};

export default LoanApplicationHeader;
